var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestLab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.817 8.206c.292 0 .529-.237.529-.53V5.249a.529.529 0 0 0-.53-.529h-5.65V1.53A.529.529 0 0 0 24.639 1H7.708a.529.529 0 0 0-.53.53v3.189H1.53A.529.529 0 0 0 1 5.25v2.428c0 .292.236.529.53.529h1.039v16.736h-.926a.529.529 0 1 0 0 1.058h29.06a.529.529 0 1 0 0-1.058h-.926V8.206h1.04Zm-.53-2.429v1.37h-5.12v-1.37h5.12Zm-22.05-3.72h15.872v1.37H8.237v-1.37Zm-6.179 3.72h5.12v1.37h-5.12v-1.37Zm1.569 2.429h3.552v16.736H3.627V8.206Zm4.61-3.72h15.872v20.456h-4.013V19.93h1.027a.529.529 0 0 0 .53-.53v-1.775a.529.529 0 0 0-.53-.53h-9.9a.529.529 0 0 0-.53.53v1.776c0 .292.237.529.53.529h1.027v5.01H8.237V4.487Zm3.514 14.387v-.718h8.844v.718h-8.843Zm3.893 1.058v5.01h-2.336v-5.01h2.336Zm1.058 5.01v-5.01h2.336v5.01h-2.336Zm12.017 0h-3.552V8.207h3.552v16.736Z",
    fill: "#2FAEF3",
    stroke: "#2FAEF3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11,
    r: 1.667,
    stroke: "#2FAEF3",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestLab);
export default __webpack_public_path__ + "static/media/icon_quest_lab.6c499f971de37e494ec10fd5b00329b0.svg";
export { ForwardRef as ReactComponent };